<template>
    <access-denied v-if="accessDenied" title="cliente" />
    <div class="page" v-else>
        <div class="vertical-flow">
            <div class="listing-header">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{ $t("cliente") }}
                        <a
                            class="pl-1"
                            v-if="hide.hideInfo"
                            @click="infoIsHidden()"
                        >
                            <b-icon
                                v-if="!hide.infoIsHidden"
                                icon="eye-off-outline"
                                type="is-danger"
                            />
                            <b-icon
                                v-if="hide.infoIsHidden"
                                icon="eye-outline"
                                type="is-success"
                            />
                        </a>
                    </h1>
                    <nav 
                        class="breadcrumb" 
                        aria-label="breadcrumbs"
                        v-if="cameFrom == 'route'"
                    >
                        <ul>
                            <li>
                                <a class="a-inativo">{{
                                    isVenda ? $t('vendas') : $t('agro')
                                }}</a>
                            </li>
                            <li>
                                <a
                                    @click="
                                        $router.push({
                                            name: `${abrev}-cliente-list`,
                                        })
                                    "
                                    >{{ $t("clientes") }}</a
                                >
                            </li>
                            <li>
                                <a aria-current="page">{{
                                    idFrom ? 
                                    `${idFrom} ${name}` 
                                    : $t("novo")
                                }}</a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="header-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        tag="button"
                        @click="$emit('voltar', true)"
                    >
                        {{ $t("voltar") }}
                    </button>
                </div>
            </div>

            <ul class="nav nav-tabs nav-tabs-main" v-if="isUpdate && cameFrom === 'route'">
                <router-link
                    tag="li"
                    :to="{
                        name: `${abrev}-cliente-dados-cadastrais-${
                            isUpdate ? 'edit' : 'new'
                        }`,
                        params: { id: idFrom },
                    }"
                >
                    <a>{{ $t("dados-cadastrais") }}</a>
                </router-link>

                <router-link
                    v-if="isUpdate && cameFrom === 'route' && permissaoPoliticaComercial.read"
                    tag="li"
                    :to="{
                        name: `${abrev}-cliente-politica-comercial-${
                            isUpdate ? 'edit' : 'new'
                        }`,
                        params: { id: idFrom },
                        query: { 
                            dadoscadastrais: abaSelecionada, 
                            politicacomercial: $route.query.politicacomercial 
                                ? $route.query.politicacomercial
                                : null,
                            analisecomercial: $route.query.analisecomercial 
                                ? $route.query.analisecomercial
                                : null,
                        },
                    }"
                >
                    <a>{{ $t("politica-comercial") }}</a>
                </router-link>

                <router-link
                    v-if="isUpdate && cameFrom === 'route' && permissaoAnaliseComercial.read"
                    tag="li"
                    :to="{
                        name: `${abrev}-cliente-analise-comercial-${
                            isUpdate ? 'edit' : 'new'
                        }`,
                        params: { id: idFrom },
                        query: { 
                            dadoscadastrais: abaSelecionada, 
                            politicacomercial: $route.query.politicacomercial 
                                ? $route.query.politicacomercial
                                : null,
                            analisecomercial: $route.query.analisecomercial 
                                ? $route.query.analisecomercial
                                : null,
                        },
                    }"
                >
                    <a>{{ $t("analise-comercial") }}</a>
                </router-link>
            </ul>

            <ul class="nav nav-tabs nav-tabs-children" v-if="isUpdate && cameFrom === 'route'">
                <li
                    v-for="(aba, i) in abas"
                    :key="i"
                    v-show="listaPermissoes[aba].read"
                    :class="{ active: abaSelecionada == i }"
                    @click="changeTab(i)"
                >
                    <a data-toggle="tab">{{ $t(aba) }}</a>
                </li>
            </ul>

            <!-- CONJUNTO DE ABAS - MOBILE -->
            <b-dropdown aria-role="list" class="mobile-tab-list">
                <div slot="trigger" class="mobile-tab">
                    <span class="mobile-tab-text">
                        {{ $t(abas[abaSelecionada]) }}
                    </span>
                    <em class="mdi mdi-chevron-down"></em>
                </div>

                <b-dropdown-item
                    class="mobile-tab-list-item"
                    :class="{ active: abaSelecionada == i }"
                    aria-role="listitem"
                    v-for="(aba, i) in abas"
                    v-show="listaPermissoes[aba].read"
                    :key="i"
                    @click="changeTab(i)"
                >
                    {{ $t(aba) }}
                </b-dropdown-item>
            </b-dropdown>

            <Geral
                ref="tabGeral"
                v-if="
                    abasAbertas['geral'] &&
                    !newToEdit &&
                    listaPermissoes['geral'].read
                "
                :idFrom="idFrom"
                v-show="abas[abaSelecionada] == 'geral'"
                :isUpdate="isUpdate"
                @isChanged="isChanged = $event"
                @name="loadName"
                @saved="reload"
            />

            <Endereco
                ref="tabEndereco"
                v-if="
                    abasAbertas['endereco'] &&
                    listaPermissoes['endereco'].read &&
                    isUpdate &&
                    cameFrom === 'route'
                "
                v-show="abas[abaSelecionada] == 'endereco'"
                :isUpdate="isUpdate"
            />

            <Empresa
                ref="tabEmpresas"
                v-if="
                    abasAbertas['empresa'] &&
                    listaPermissoes['empresa'].read &&
                    isUpdate &&
                    cameFrom === 'route'
                "
                v-show="abas[abaSelecionada] == 'empresa'"
            />

            <Vendedores
                ref="tabVendedores"
                v-if="
                    abasAbertas['vendedor'] &&
                    listaPermissoes['vendedor'].read &&
                    isUpdate &&
                    cameFrom === 'route'
                "
                v-show="abas[abaSelecionada] == 'vendedor'"
                :isUpdate="isUpdate"
            />

            <Licenca
                ref="tabLicenca"
                v-if="
                    abasAbertas['licenca'] &&
                    listaPermissoes['licenca'].read &&
                    isUpdate &&
                    cameFrom === 'route'
                "
                v-show="abas[abaSelecionada] == 'licenca'"
                :isUpdate="isUpdate"
            />

            <Anexos
                ref="tabAnexos"
                v-if="
                    abasAbertas['anexo'] &&
                    listaPermissoes['anexo'].read &&
                    isUpdate &&
                    cameFrom === 'route'
                "
                v-show="abas[abaSelecionada] == 'anexo'"
            />
            <!-- @70954 - adaptado para vendas, cliente aba propriedade-->
            <Propriedades
                ref="tabPropriedades"
                v-if="
                    abasAbertas['propriedade'] &&
                    listaPermissoes['propriedade'].read &&
                    isUpdate &&
                    cameFrom === 'route'
                "
                v-show="abas[abaSelecionada] == 'propriedade'"
                :isUpdate="isUpdate"
            />

            <Transportadora
                ref="tabTransportadora"
                v-if="
                    abasAbertas['transportadora'] &&
                    listaPermissoes['transportadora'].read &&
                    isUpdate &&
                    cameFrom === 'route'
                "
                v-show="abas[abaSelecionada] == 'transportadora'"
                :isUpdate="isUpdate"
            />

            <Contato
                ref="tabContatos"
                v-if="
                    abasAbertas['contato'] &&
                    listaPermissoes['contato'].read &&
                    isUpdate &&
                    cameFrom === 'route'
                "
                v-show="abas[abaSelecionada] == 'contato'"
                :isUpdate="isUpdate"
            />

            <HistoricoEmail
                ref="tabHistoricoEmail"
                v-if="
                    abasAbertas['historico-email'] &&
                    listaPermissoes['historico-email'].read &&
                    isUpdate &&
                    cameFrom === 'route'
                "
                v-show="abas[abaSelecionada] == 'historico-email'"
                :isUpdate="isUpdate"
            />

            <AreaInteresse
                ref="tabAreaInteresse"
                v-if="
                    abasAbertas['cli-areainteresse'] &&
                    listaPermissoes['cli-areainteresse'].read &&
                    isUpdate &&
                    cameFrom === 'route'
                "
                v-show="abas[abaSelecionada] == 'cli-areainteresse'"
                :isUpdate="isUpdate"
            />
            <LogIntegracao
                ref="tabLogIntegracao"
                v-if="
                    abasAbertas['cli-logintegracao'] &&
                    listaPermissoes['cli-logintegracao'].read &&
                    isUpdate &&
                    cameFrom === 'route'
                "
                v-show="abas[abaSelecionada] == 'cli-logintegracao'"
                :isUpdate="isUpdate"
            />
        </div>
    </div>
</template>

<script>
import VendasClienteService from "@/services/VendasClienteService";
import MailQueueService from "@/services/MailQueueService";
import ClienteService from "@/services/vendas/cliente/ClienteService";
import HideInfo from "@/components/shared/HideInfo";
import { mapState } from "vuex";

// Abas
import Geral from "@/components/vendas/cliente/abas/dados-cadastrais/Geral";
import Endereco from "@/components/vendas/cliente/abas/dados-cadastrais/Endereco";
import Empresa from "@/components/vendas/cliente/abas/dados-cadastrais/Empresa";
import Vendedores from "@/components/vendas/cliente/abas/dados-cadastrais/Vendedores";
import Licenca from "@/components/vendas/cliente/abas/dados-cadastrais/Licenca";
import Anexos from "@/components/vendas/cliente/abas/dados-cadastrais/Anexos";
import Propriedades from "@/components/vendas/cliente/abas/dados-cadastrais/Propriedades";
import Transportadora from "@/components/vendas/cliente/abas/dados-cadastrais/Transportadora";
import Contato from "@/components/vendas/cliente/abas/dados-cadastrais/Contato";
import HistoricoEmail from "@/components/vendas/cliente/abas/dados-cadastrais/HistoricoEmail";
import AreaInteresse from "@/components/vendas/cliente/abas/dados-cadastrais/AreaInteresse";
import LogIntegracao from "@/components/vendas/cliente/abas/dados-cadastrais/LogIntegracao";

export default {
    name: 'AbaDadosCadastrais',
    components: {
        Geral,
        Endereco,
        Empresa,
        Vendedores,
        Licenca,
        Anexos,
        Propriedades,
        Transportadora,
        Contato,
        HistoricoEmail,
        HideInfo,
        AreaInteresse,
        LogIntegracao,
    },
    props: {
        cameFrom: {
            type: String,
            default: 'route',
        },
        idFrom: {
            type: Number,
            default: 0,
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
        newToEdit: {
            type: Boolean,
            default: false,
        },
        abrev: {
            type: String,
            default: 'ven',
        },
    },
    data() {
        return {
            id: 0,
            abaSelecionada: 0,
            // Seguir nome na tabela app_tela e usar estes nomes no dicionário para criação dinâmica de listaPermissoes e abasAbertas
            abas: [
                "geral",
                "empresa",
                "vendedor",
                "licenca",
                "anexo",
                "propriedade",
                "transportadora",
                "endereco",
                "contato",
                "historico-email",
                "cli-areainteresse",
                "cli-logintegracao",
            ],
            abasAbertas: {},
            permissaoDadosCadastrais: false,
            permissaoPoliticaComercial: false,
            permissaoAnaliseComercial: false,
            listaPermissoes: {},
            isChanged: false,
            cliente: null,
            name: '',

            // Vai ser retirado
            service: new VendasClienteService(this.$http, this.$router),
            serviceCliente: new ClienteService(this.$http, this.$router),
            mailQueueService: new MailQueueService(this.$http, this.$router),
            tabData: {
                email: {
                    isLoading: false,
                    table: [],
                    page: 1,
                    perPage: 20,
                    total: 0,
                },
                anexos: {
                    page: 1,
                    perPage: 20,
                },
            },
            loadingAnexo: false,

            isVenda: this.$route.meta.contexto == "vendas",
            isAgro: this.$route.meta.contexto == "agro",

            accessDenied: false,
        };
    },
    mounted() {
        // @85391 - Descontinuado uso da query abaSelecionada em telas que possuem aba e sub-abas
        // if (this.$route.query.abaSelecionada) {
        //     this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        // } else 
        if (this.$route.query.dadoscadastrais && this.idFrom) {
            this.changeTab(this.$route.query.dadoscadastrais < this.abas.length 
                ? this.$route.query.dadoscadastrais
                : 0
            );
        }
    },
    created() {

        if (this.isVenda) {
            this.permissaoDadosCadastrais = this.hasPermissionAccess(
                "vendas",
                "clientes",
                "ven-cliente-dados-cadastrais"
            );
        }else if (this.isAgro){
            this.permissaoDadosCadastrais = this.hasPermissionAccess( 
                'agro', 
                'clientes', 
                'agro-cliente-dados-cadastrais'
            );
        }

        if (
            (!this.isUpdate && !this.permissaoDadosCadastrais.create) ||
            (this.isUpdate && !this.permissaoDadosCadastrais.read)
        ) {
            this.accessDenied = true;
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "clientes" },
            });
        } else {
            // Criação dinâmica de listaPermissoes e abasAbertas baseado no nome das tabs
            for (let [key, value] of Object.entries(this.abas)) {
                if (value == "propriedade") {
                    this.abasAbertas[value] = false;
                    this.listaPermissoes[value] = this.hasPermissionAccess(
                        "agro",
                        "agro-cadastros",
                        "agro-propriedade"
                    );
                } else {
                    this.abasAbertas[value] = false;
                    if (this.isVenda) {
                        this.listaPermissoes[value] = this.hasPermissionAccess(
                            'vendas',
                            'clientes',
                            `ven-cliente-dados-cadastrais-${value}`
                        );
                    }else if (this.isAgro) {
                        this.listaPermissoes[value] = this.hasPermissionAccess(
                            'agro', 
                            'clientes', 
                            `agro-cliente-dados-cadastrais-${value}`
                        );
                    }
                }
            }

            if (this.isVenda) {
                this.permissaoAnaliseComercial = this.hasPermissionAccess(
                    "vendas",
                    "clientes",
                    'ven-cliente-analise-comercial'
                );
                this.permissaoPoliticaComercial = this.hasPermissionAccess(
                    "vendas",
                    "clientes",
                    'ven-cliente-politica-comercial'
                );
            }else if (this.isAgro) {
                this.permissaoAnaliseComercial = this.hasPermissionAccess(
                    'agro', 
                    'clientes', 
                    'agro-cliente-analise-comercial'
                );
                this.permissaoPoliticaComercial = this.hasPermissionAccess(
                    'agro', 
                    'clientes', 
                    'agro-cliente-politica-comercial'
                );
            }

            // Pegar dinâmicamente a primeira aba que estivar com permissão de leitura para a mesma iniciar visível
            for (let [key, value] of Object.entries(this.listaPermissoes)) {
                if (value.read) {
                    this.abaSelecionada = this.abas.findIndex((e) => e == key);
                    this.abasAbertas[key] = true;
                    break;
                }
            }
            // Vai ser retirado
            this.id = this.idFrom;
        }
    },
    computed: {
        ...mapState(["hide"]),
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
            // fim
        },
        loadName(name) {
            this.name = ' - ' + name;
        },
        reload(id) {
            this.$emit('saved', id);
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },

        showMessageFromTab(data) {
            this.$root.showMessage(data.type, data.message);
        },
        loadTabAnexos(info, fromDelete = false) {
            this.tabData.anexos.page = info.page;

            this.serviceCliente.find(this.idFrom).then((result) => {
                this.cliente = result.content;

                this.service
                    .loadAnexos(
                        this.id,
                        info.page ? info.page - 1 : 0,
                        info.limit ? info.limit : 20,
                        info.column,
                        info.order,
                        this.cliente.cnpjcpf
                    )
                    .then((r) => {
                        if (r.status != 200) {
                            console.error(
                                `Status ${r.status} ao carregar aba anexos.`
                            );
                            console.error(
                                r.message ? r.message : "Sem mensagem."
                            );
                            this.$root.showMessage(
                                "error",
                                "msg-erro-ven-cliente-anexo-anexo"
                            );
                        } else {
                            this.tabData.anexos = r.content;
                            this.tabData.anexos.total = r.totalElements;
                            this.tabData.anexos.page = info.page;

                            if (this.$refs.tabAnexos != undefined) {
                                this.$refs.tabAnexos.$forceUpdate();
                            }
                        }
                    })
                    .catch((e) => {
                        console.error("Erro ao carregar aba licenca", e);
                        this.$root.showMessage(
                            "error",
                            "msg-erro-ven-cliente-licenca-load"
                        );
                    })
                    .finally(() => {
                        if (this.$refs.tabAnexos && fromDelete) {
                            this.$refs.tabAnexos.onFinishedExclusion();
                        }
                    });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.page {
    position: relative;
    padding-left: 0;
    .nav-tabs-main {
        margin-bottom: 10px;
    }
    .nav-tabs-children {
        margin-bottom: 20px;
        li > a {
            text-transform: capitalize;
        }
        li > ::after {
            bottom: -4px;
            border-width: 2px;
        }
    }

    .mobile-tab {
        cursor: pointer;

        &-list {
            width: calc(100% + 40px);
            margin-top: 20px;
            margin-bottom: 20px;
            margin-left: -20px;
            padding-right: 20px;
            padding-bottom: 5px;
            padding-left: 20px;
            border-bottom: 1px solid $table-border;
            justify-content: center;

            &::after {
                content: "";
                border: 3px solid $primary-color-click;
                border-radius: 100px;
                position: absolute;
                width: calc(100% - 40px);
                bottom: -3px;
            }

            &-item {
                text-transform: uppercase;
                font-weight: 600;
                color: $text-color;

                &.active {
                    color: $primary-color-click;
                }
            }
        }

        &-text {
            text-transform: uppercase;
            font-weight: 600;
            color: $primary-color-click;

            & ~ i {
                color: $primary-color-click;
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
